import { Plus } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { parseError } from '@/lib/errors'
import { useCreateEmailTemplate } from '@/models/emailTemplate'

interface NewTemplateButtonProps {
  isGlobal: boolean
  onCreated: (id: string) => void
}

export function NewTemplateButton({ isGlobal, onCreated }: NewTemplateButtonProps) {
  const createMutation = useCreateEmailTemplate()

  function handleCreate() {
    createMutation.mutate(
      { subject: 'Untitled', body: '', isGlobal },
      {
        onSuccess: (created) => onCreated(created.id),
        onError: (err) => toast.error(parseError(err)),
      }
    )
  }

  return (
    <Button
      onClick={handleCreate}
      loading={createMutation.isPending ? 'Creating…' : undefined}
      className="text-md w-full justify-start"
    >
      <Plus />
      New template
    </Button>
  )
}
